// extracted by mini-css-extract-plugin
export default {"scheduler":"scheduler_scheduler__-ZhTY","calendar":"scheduler_calendar__ewcax","calendar_btn":"scheduler_calendar_btn__16sbd"};